/*=============================================== CardAction ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled, { css } from "styled-components";
import Variables from "./Variables";
import { H5, P } from "./Font";
import Mixins from "./Mixins";
import CardContainer from "./CardContainer";
import Image from "./Image";
import FajnyIcon from "./FajnyIcon";
import Flexbox from "./Flexbox";
import Button from "./Button";
/*==================== Component ====================*/
var CardAction = function (_a) {
    var _b = _a.orientation, orientation = _b === void 0 ? "portrait" : _b, onClickLike = _a.onClickLike, isLikedChecked = _a.isLikedChecked, src = _a.src, alt = _a.alt, rating = _a.rating, title = _a.title, content = _a.content, buttonText = _a.buttonText, _c = _a.buttonStyle, buttonStyle = _c === void 0 ? "plain" : _c, _d = _a.buttonColor, buttonColor = _d === void 0 ? "primary" : _d, onClickButton = _a.onClickButton, toButton = _a.toButton, iconLeftButton = _a.iconLeftButton, iconRightButton = _a.iconRightButton, _e = _a.iconLike, iconLike = _e === void 0 ? "heart-solid" : _e, _f = _a.iconLiked, iconLiked = _f === void 0 ? "heart-full-solid" : _f, _g = _a.iconRating, iconRating = _g === void 0 ? "star-full-solid" : _g, props = __rest(_a, ["orientation", "onClickLike", "isLikedChecked", "src", "alt", "rating", "title", "content", "buttonText", "buttonStyle", "buttonColor", "onClickButton", "toButton", "iconLeftButton", "iconRightButton", "iconLike", "iconLiked", "iconRating"]);
    return (React.createElement(Container, __assign({ "$orientation": orientation }, props),
        React.createElement(ImgContainer, { "$orientation": orientation },
            React.createElement(Image, { src: src, alt: alt, width: "100%", height: "100%", fit: "cover" }),
            onClickLike && (React.createElement(LikeButton, { onClick: onClickLike },
                React.createElement(FajnyIcon, { name: isLikedChecked ? iconLiked : iconLike, size: 24 })))),
        React.createElement(Content, { "$orientation": orientation },
            rating ? (React.createElement(Flexbox, { justify: "space-between", align: "center", gap: "xs" },
                React.createElement(H5, null, title),
                React.createElement(Rating, null,
                    React.createElement(FajnyIcon, { name: iconRating, size: 12, color: "primary" }),
                    rating))) : (React.createElement(H5, null, title)),
            content && React.createElement(P, null, content),
            buttonText && (React.createElement(Flexbox, { justify: "flex-end" },
                React.createElement(Button, { buttonStyle: buttonStyle, color: buttonColor, fajnyIconLeft: iconLeftButton, fajnyIconRight: iconRightButton, to: toButton, onClick: onClickButton }, buttonText))))));
};
export default CardAction;
/*==================== Types ====================*/
var orientation = {
    portrait: "portrait",
    landscape: "landscape",
};
/*==================== Styles ====================*/
var Container = styled(CardContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), function (_a) {
    var $orientation = _a.$orientation;
    return Mixins.Flexbox({
        $direction: $orientation === "landscape" ? "row" : "column",
        $align: "stretch",
    });
});
var ImgContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n    position: relative;\n    min-height: ", ";\n    ", ";\n\n    img {\n        position: relative;\n        z-index: 0;\n\n        ", ";\n    }\n"], ["\n    width: ", ";\n    height: ", ";\n    position: relative;\n    min-height: ", ";\n    ", ";\n\n    img {\n        position: relative;\n        z-index: 0;\n\n        ", ";\n    }\n"])), function (_a) {
    var $orientation = _a.$orientation;
    return ($orientation === "portrait" ? "100%" : "100px");
}, function (_a) {
    var $orientation = _a.$orientation;
    return ($orientation === "portrait" && "150px");
}, function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === "landscape" && "120px";
}, Mixins.Flexbox({
    $align: "stretch",
}), function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === "landscape" && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                min-height: 120px;\n            "], ["\n                min-height: 120px;\n            "])));
});
var sizeLikeButton = 32;
var LikeButton = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    bottom: ", ";\n    right: ", ";\n    width: ", "px;\n    height: ", "px;\n    padding: 0;\n    border: none;\n    background-color: transparent;\n    ", ";\n    color: ", ";\n    cursor: pointer;\n    border-radius: ", ";\n    transition: ", ";\n\n    @media ", " {\n        &:hover {\n            background-color: ", ";\n        }\n\n        &:active {\n            background-color: ", ";\n        }\n    }\n"], ["\n    position: absolute;\n    bottom: ", ";\n    right: ", ";\n    width: ", "px;\n    height: ", "px;\n    padding: 0;\n    border: none;\n    background-color: transparent;\n    ", ";\n    color: ", ";\n    cursor: pointer;\n    border-radius: ", ";\n    transition: ", ";\n\n    @media ", " {\n        &:hover {\n            background-color: ", ";\n        }\n\n        &:active {\n            background-color: ", ";\n        }\n    }\n"])), Variables.Spacers.XS, Variables.Spacers.XS, sizeLikeButton, sizeLikeButton, Mixins.Flexbox({
    $align: "center",
    $justify: "center",
}), Variables.Colors.White, Variables.Radiuses.Circle, Variables.Transitions.Short, Variables.Breakpoints.Hover, Variables.Colors.Gray300, Variables.Colors.Gray100);
var Content = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", ";\n    ", ";\n\n    & > * {\n        width: 100%;\n    }\n\n    ", "\n"], ["\n    padding: ", ";\n    ", ";\n\n    & > * {\n        width: 100%;\n    }\n\n    ", "\n"])), Variables.Spacers.XS, Mixins.Flexbox({
    $align: "flex-start",
    $justify: "flex-start",
    $direction: "column",
    $gap: "xxs",
}), function (_a) {
    var $orientation = _a.$orientation;
    return $orientation === "landscape" && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            flex-grow: 1;\n        "], ["\n            flex-grow: 1;\n        "])));
});
var Rating = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), Mixins.Flexbox({
    $inline: true,
    $align: "center",
    $justify: "flex-start",
    $gap: "xxs",
}));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
